import success from "./Icons/success";
import error from "./Icons/error";
import { toast } from "react-toastify";
export const showToast = (
    message,
    type,
    toastId
) => {
    let displayMessage = message;
    if (typeof message === 'object' && message !== null) {
        displayMessage = message.resMessage || message.message || JSON.stringify(message);
    }

    if (type === "success") {
        toast.success(displayMessage, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            className: `toast_${type}`,
            toastId: toastId || undefined,
        });
    } else {
        toast.error(displayMessage, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            className: `toast_${type}`,
            toastId: toastId || undefined,
        });
    }

};